// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';
import {
  SPOT_GREY_2,
  SPOT_GREY_7
} from '@thredup/styleguide/src/variables/colors';

const Bar: React.FC<BarItemProps> = (props) => {
  const { data, color, height, label, width, x, y } = props;
  const { indexValue, value } = data;
  const isSecondhand = indexValue === 'Secondhand';
  const isSustainableFashion = indexValue === 'Sustainable Fashion';
  const isFastFashion = indexValue === 'Fast Fashion';
  const isPositive = value > 0;
  const labelX = isPositive ? width + 20 : -20;
  const translateX = isPositive ? x + 5 : x - 5;
  const annotationProps = {
    className: 'text-sm max-w-sm text-gray-7',
    dx: 0,
    width: 158,
    y: 0,
    style: {
      fill: SPOT_GREY_7
    }
  };

  const annotationSecondhand = (
    <g transform={`translate(323, 17)`}>
      <line x1="-55" y1="0" x2="-10" y2="0" stroke={SPOT_GREY_2} />
      <text {...annotationProps}>
        <tspan>
          <tspan fontWeight="bold">Secondhand</tspan> steals more
        </tspan>
        <tspan x="0" dy="1.2em">
          share of wallet than any
        </tspan>
        <tspan x="0" dy="1.2em">
          other sector for the 4th
        </tspan>
        <tspan x="0" dy="1.2em">
          year in a row.
        </tspan>
      </text>
    </g>
  );

  const annotationSustainable = (
    <g transform={`translate(323, 77)`}>
      <line x1="-30" y1="0" x2="-10" y2="0" stroke={SPOT_GREY_2} />
      <line x1="-30" y1="0" x2="-30" y2="-60" stroke={SPOT_GREY_2} />
      <line x1="-55" y1="-60" x2="-30" y2="-60" stroke={SPOT_GREY_2} />
      <text {...annotationProps}>
        <tspan>
          <tspan fontWeight="bold">Sustainable fashion</tspan>
        </tspan>
        <tspan x="0" dy="1.2em">
          jumps <tspan fontWeight="bold">138%</tspan> from last
        </tspan>
        <tspan x="0" dy="1.2em">
          year and unseats
        </tspan>
        <tspan x="0" dy="1.2em">
          Amazon for #2 position.
        </tspan>
      </text>
    </g>
  );

  const annotationFastFashion = (
    <g transform={`translate(323, 17)`}>
      <line x1="-55" y1="0" x2="-10" y2="0" stroke={SPOT_GREY_2} />
      <text {...annotationProps}>
        <tspan>
          <tspan fontWeight="bold">Fast fashion</tspan> growth
        </tspan>
        <tspan x="0" dy="1.2em">
          stagnates, as it fails to gain
        </tspan>
        <tspan x="0" dy="1.2em">
          market share for first time.
        </tspan>
      </text>
    </g>
  );

  return (
    <g transform={`translate(${translateX}, ${y})`}>
      <rect
        fill={color}
        height={height}
        stroke="white"
        strokeWidth="0"
        width={width}
      />

      <text
        className="font-bold text-sm"
        dominantBaseline="central"
        textAnchor="middle"
        x={labelX}
        y={17}
      >
        {`${label}%`}
      </text>
      {isSecondhand && isPositive && annotationSecondhand}
      {isSustainableFashion && isPositive && annotationSustainable}
      {isFastFashion && isPositive && annotationFastFashion}
    </g>
  );
};

export { Bar };
